// extracted by mini-css-extract-plugin
export default {"content":"styles_content__ACaMV","header":"styles_header__RzhCI","squircle":"styles_squircle__38kjM","icon":"styles_icon__7TiIJ","skeleton":"styles_skeleton__BcX+9"};